interface PeopleEntity {
  name: string;
  phone: string;
  position: string;
}
export interface CreateLocationDto {
  binusianId: string;
  locationName: string;
  bmName: string;
  address: string;
  phone: string;
  ext: string;
  email: string;
  manager: PeopleEntity;
  personInCharge: PeopleEntity[];
  vision: string;
  mission: string[];
  strategy: string[];
  imageName: string;
  imageBase64?: string;
  instagram?: string;
  facebook?: string;
  tiktok?: string;
  youtube?: string;
}

export namespace CreateLocationDto {
  export function removeEmptyStringProperties(
    dto: CreateLocationDto
  ): CreateLocationDto {
    const cleanedDto: CreateLocationDto = { ...dto };

    for (const key in cleanedDto) {
      if (
        Object.prototype.hasOwnProperty.call(cleanedDto, key) &&
        cleanedDto[key] === ""
      ) {
        delete cleanedDto[key];
      }
    }

    return cleanedDto;
  }
}
